module.exports = __webpack_public_path__ + "static/media/loading.e0966120.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading.svg
// module id = 701
// module chunks = 0